import * as React from 'react';
import './ContactSelect.scss';
import UserModel from 'src/model/user.model';
import env from 'src/shared/env';

const BASE_URL = env.REACT_APP_BASE_WORDPRESS_URL;

interface IContactSelectProps {
  onChange(value: string): void;
  value: string;
  userData: UserModel;
  loading: boolean;
  getUserDetails(): void;
}

export class ContactSelect extends React.Component<IContactSelectProps, any> {
  public componentDidMount() {
    this.props.getUserDetails();
  }

  private renderEmail = (): string => {
    return this.props.userData.email;
  };

  private renderPhone = (): string => {
    return this.props.userData.mobileNumber;
  };

  private renderNoContact() {
    return (
      <div>
        <p className="rp-contactselect--p">
          It seems you don't have an Email or Mobile Phone Number registered
          with us.
        </p>
        <p className="rp-contactselect--p">
          Please <a href={`${BASE_URL}contact-us/`}>contact support</a> to
          update this information.
        </p>
      </div>
    );
  }

  private renderContacts() {
    const { userData, value } = this.props;
    return (
      <React.Fragment>
        {userData.email && userData.email.length ? (
          <div
            className="rp-contactselect--item"
            onClick={() => this.props.onChange(userData.email)}
          >
            <span className="rp-contactselect--item--check">
              {value === userData.email ? (
                <i className="rpds rpds-radio-button-checked" />
              ) : (
                <i className="rpds rpds-radio-button-unchecked" />
              )}
            </span>
            <span>
              <div className="rp-contactselect--item--title">via email:</div>
              <div>
                <span className="rp-contactselect--item--content">
                  {this.renderEmail()}
                </span>
                <span className="rp-contactselect--item--contenticon">
                  <i className="rpds rpds-mail" />
                </span>
              </div>
            </span>
          </div>
        ) : null}

        {userData.mobileNumber && userData.mobileNumber.length ? (
          <div
            className="rp-contactselect--item"
            onClick={() => this.props.onChange(userData.mobileNumber)}
          >
            <span className="rp-contactselect--item--check">
              {value === userData.mobileNumber ? (
                <i className="rpds rpds-radio-button-checked" />
              ) : (
                <i className="rpds rpds-radio-button-unchecked" />
              )}
            </span>
            <span>
              <div className="rp-contactselect--item--title">via SMS:</div>
              <div>
                <span className="rp-contactselect--item--content">
                  {this.renderPhone()}
                </span>
                <span className="rp-contactselect--item--contenticon">
                  <i className="rpds rpds-question-answer" />
                </span>
              </div>
            </span>
          </div>
        ) : null}
      </React.Fragment>
    );
  }

  private renderLoading() {
    return (
      <React.Fragment>
        <div className="rp-contactselect--item">
          <span className="rp-contactselect--item--check">
            <i className="rpds rpds-radio-button-unchecked" />
          </span>
          <span>
            <div className="rp-contactselect--item--title loading-bar title" />
            <div>
              <span className="rp-contactselect--item--content loading-bar" />
              <span className="rp-contactselect--item--contenticon">
                <i className="rpds rpds-mail" />
              </span>
            </div>
          </span>
        </div>

        <div className="rp-contactselect--item">
          <span className="rp-contactselect--item--check">
            <i className="rpds rpds-radio-button-unchecked" />
          </span>
          <span>
            <div className="rp-contactselect--item--title loading-bar title" />
            <div>
              <span className="rp-contactselect--item--content loading-bar" />
              <span className="rp-contactselect--item--contenticon">
                <i className="rpds rpds-question-answer" />
              </span>
            </div>
          </span>
        </div>
      </React.Fragment>
    );
  }

  public render() {
    const { userData } = this.props;
    return (
      <div className="rp-contactselect no-select">
        {this.props.loading
          ? this.renderLoading()
          : (userData.mobileNumber && userData.mobileNumber.length) ||
            (userData.email && userData.email.length)
          ? this.renderContacts()
          : this.renderNoContact()}
      </div>
    );
  }
}
